import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { disputeReducers } from './reducers/dispute.reducer';
import { DisputeEffects } from './effects/dispute.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('dispute', disputeReducers),
    EffectsModule.forFeature([DisputeEffects]),
  ],
})
export class DisputeStoreModule {}
